import React from "react";

import { toAbsoluteUrl } from "../../assets/helpers/AssetHelpers";
import images from "./logo.json";
import useReRouteHook from "../../assets/hooks/useReRouteHook";
import { Categories } from "../../types/types";
import "./style.css";

interface Images {
  category_name: string;
  url: string;
}

const MainSectionCard = ({
  cards,
  index,
  activeCategoryName,
  activeCategoryId,
  isHomePage
}: {
  cards: Omit<Categories, "is_group" | "level" | "sorting_order">;
  index: number;
  activeCategoryName?: string;
  activeCategoryId?: string;
  isHomePage?: boolean;
}) => {
  const { reRouteButtonRenderer } = useReRouteHook();


  const filterimage: Images[] = images?.filter(
    (item: any) => item.category_name === cards.category_name.toUpperCase(),
  );

  if (cards.parent_cms_category !== null && cards.parent_cms_category !== "") {
    return null;
  }

  const imageUrl = filterimage[0]?.url ?? null;

  const collapseId = `accordion-collapse-${cards.new_id || index}`;
  const headingId = `accordion-heading-${cards.new_id || index}`;
  const isOpen = cards.subcategories?.some(
    (subcategory: Categories) =>
      subcategory.category_name === activeCategoryName || subcategory.new_id === activeCategoryId,
  );

  return (
    <div className="accordion-item border rounded-3 mb-3">
      {/* ── Header ── */}
      <h2 className="accordion-header" id={headingId}>
        <button
          className={`accordion-button main-section-header-accordion d-flex align-items-center gap-2 ${
            isOpen ? "" : "collapsed"
          }`}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#${collapseId}`}
          aria-expanded={isOpen ? "true" : "false"}
          aria-controls={collapseId}
        >
          {imageUrl && (
            <img
              src={toAbsoluteUrl(imageUrl)}
              alt={cards.category_name}
              className="main-section-img"
            />
          )}
          <span className="accordion-category-title">{cards.category_name}</span>
        </button>
      </h2>

      {/* ── Body ── */}
      <div
        id={collapseId}
        className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
        aria-labelledby={headingId}
        {...(isHomePage ? {} : { "data-bs-parent": "#sideBarAccordian" })}
      >
        <div className="accordion-body main-section-body-accordion accordion-body-divider pt-0">
          <ul className=" mb-0">
            {cards.subcategories &&
              cards.subcategories.map((subcategory: Categories) => {
                const isActive =
                  subcategory.category_name === activeCategoryName ||
                  subcategory.new_id === activeCategoryId;

                return (
                  <li key={subcategory.id} className="py-2">
                    {reRouteButtonRenderer({
                      url: `/category/${cards.new_id}/${subcategory?.new_id}`,
                      classes: `align-items-center d-flex fs-16 justify-content-between w-100 link-hover p-0 ${
                        isActive ? "in_bold main-section-active-link" : "in_med color43"
                      }`,
                      nameText: subcategory.category_name,
                      spanClasses: isActive ? "main-section-active-link" : "",
                      // endAdornment: (
                      //   <img
                      //     src={toAbsoluteUrl("mainsection-images/left-arrow.svg")}
                      //     alt={subcategory.id}
                      //   />
                      // ),
                    })}
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MainSectionCard;
